module.exports = __webpack_public_path__ + "img/product-img22.36ab5fb4.png";